module.exports = __webpack_public_path__ + "static/media/btn-prestamos.0c97b17c.png";